export default "__VITE_ASSET__CwuyXtWT__"